import login from 'shared/api/login';
import monolith from 'shared/api/monolith';

export default {
  Login: login,
  Monolith: monolith,
};
